export const authErrorMessages = {
  TOKEN_EXPIRED: 'Access token expired',
};
